import axios, { AxiosResponse } from 'axios';
import { IIdResult } from '../../../models/session.types';
import EnvWindow from '../../../utils/env';

export async function getExamGradeRule(id: string): Promise<AxiosResponse<ArrayBuffer>> {
  const response = await axios.get(`${EnvWindow.REACT_APP_EXAMS__EXAM_GRADE_RULE_API_URL}/${id}/document`, {
    responseType: 'arraybuffer',
  });
  return response;
}

export async function modifyExamGradeRule(
  examGradeRuleId: string,
  missingAnswer: boolean,
  automaticScore: boolean,
  file: File | undefined,
): Promise<AxiosResponse<string>> {
  const requestBody = new FormData();
  requestBody.append('AutomaticScore', automaticScore ? 'true' : 'false');
  requestBody.append('NoAnswer', missingAnswer ? 'true' : 'false');
  requestBody.append('ExamGradeRuleId', examGradeRuleId);
  if (file) {
    requestBody.append('FormFile', file);
  }
  return await axios({
    method: 'PUT',
    url: `${EnvWindow.REACT_APP_EXAMS__EXAM_GRADE_RULE_API_URL}`,
    data: requestBody,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export async function createExamGradeRule(
  examTaskId: string,
  noAnswer: boolean,
  automaticScore: boolean,
  file: File | undefined,
): Promise<AxiosResponse<IIdResult>> {
  const requestBody = new FormData();
  requestBody.append('AutomaticScore', automaticScore ? 'true' : 'false');
  requestBody.append('NoAnswer', noAnswer ? 'true' : 'false');
  requestBody.append('ExamTaskId', examTaskId);
  if (file) {
    requestBody.append('FormFile', file);
  }
  const response = await axios({
    method: 'POST',
    url: `${EnvWindow.REACT_APP_EXAMS__EXAM_GRADE_RULE_API_URL}`,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: requestBody,
  });
  return response;
}

export async function DeleteExamGradeRuleAttachment(Id: string): Promise<AxiosResponse<string>> {
  return await axios({
    method: 'DELETE',
    url: `${EnvWindow.REACT_APP_EXAMS__EXAM_GRADE_RULE_API_URL}/${Id}/document`,
  });
}
